module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedBold.9264ba6.woff2";